import type {ThunkDispatchType} from "../../app/reducers/IMainAppState";
import {LoadTermTemplates} from "../../shared/actions/UtilsActionCreators";
import {useDispatch} from "react-redux";
import type {ReactNode} from "react";
import React, { useEffect, useState} from "react";
import type TermNameType from "../../shared/term/objects/TermNameType";
import Loader from "../../shared/components/Loader";
import type TermTemplate from "../../shared/term/objects/TermTemplate";

export interface IMerchantTermTemplatesLoaderProps {
    termName: TermNameType;
    countryCode: string;
    children: (termTemplates: TermTemplate[]) => ReactNode;
}

export default (props: IMerchantTermTemplatesLoaderProps) => {
    const { termName, countryCode, children } = props;
    const [termTemplatesPromise, setTermTemplatesPromise] = useState(undefined);

    const dispatch: ThunkDispatchType = useDispatch();
    useEffect(() => {
        setTermTemplatesPromise(dispatch(LoadTermTemplates(termName, countryCode)));
    }, [dispatch, termName, countryCode]);

    return (
        <Loader promise={termTemplatesPromise}>
            {(termTemplates: TermTemplate[]) => (
                children(termTemplates)
            )}
        </Loader>
    );

}